import { Button, Stack, Grid, Paper, Typography } from "@mui/material";
import { useThemePreference } from "../../contexts/ThemeContext";

const Tools = ({ onDeliver, onDeliverNoPricing, onRevision, handleDeliverConfirmation, onCopyToNew, onRefreshPricing, handleOpenDrawingModal, readOnly = false }) => {
    const { isDarkMode } = useThemePreference();

    return (
        <Grid className="hive-quote-tools" container spacing={2}>
            <Grid item xs={12} md={6}>
                <Paper className="hive-quote-tools-card" variant="outlined" sx={{ p: 2 }}>
                    <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700 }}>Quote Tools</Typography>

                    <Stack spacing={1}>
                        <Button fullWidth variant={isDarkMode ? "outlined" : "contained"} color="primary" onClick={onRevision} disabled={readOnly}>Create Revision</Button>
                        <Button fullWidth variant={isDarkMode ? "outlined" : "contained"} color="primary" onClick={onCopyToNew} disabled={readOnly}>Copy To Opportunity</Button>
                        <Button fullWidth variant={isDarkMode ? "outlined" : "contained"} color="primary" onClick={onRefreshPricing} disabled={readOnly}>Refresh Pricing</Button>
                        <Button fullWidth variant={isDarkMode ? "outlined" : "contained"} color="secondary" onClick={onDeliver}>Convert To PDF</Button>
                        <Button fullWidth variant={isDarkMode ? "outlined" : "contained"} color="secondary" onClick={onDeliverNoPricing}>Convert to PDF Without Pricing</Button>
                        <Button fullWidth variant={isDarkMode ? "outlined" : "contained"} color="secondary" onClick={handleOpenDrawingModal} disabled={readOnly}>Convert To PDF With Drawing</Button>
                    </Stack>

                </Paper>
            </Grid>

            <Grid item xs={12} md={6}>
                <Paper className="hive-quote-tools-card" variant="outlined" sx={{ p: 2 }}>
                    <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700 }}>PM Tools</Typography>
                    <Stack spacing={1}>
                        <Button fullWidth variant={isDarkMode ? "outlined" : "contained"} color="success" onClick={handleDeliverConfirmation} disabled={readOnly}>Order Confirmation</Button>
                    </Stack>
                </Paper>
            </Grid>
    </Grid>
  );
};

export default Tools;

